// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3BS6L","result":"search_result__1--eD","loader":"search_loader__O8Dfy"};